import { useTranslation } from "react-i18next";

export default function useTranslate() {
  const { t: translate } = useTranslation();
  return translate;
}
